import React from 'react';

const Marquee = ({ items }) => {
  return (
    <div className="w-full overflow-hidden bg-brand-accent text-white py-4 flex items-center border-y border-brand-dark/10">
      <div className="flex whitespace-nowrap animate-marquee">
        {[...Array(2)].map((_, i) => (
          <div key={i} className="flex items-center shrink-0">
            {items.map((item, idx) => (
              <React.Fragment key={idx}>
                <span className="text-sm md:text-base font-medium tracking-[0.2em] uppercase px-8">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-white/30"></span>
              </React.Fragment>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;